module.exports = "<p>\n  chat works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/chat/chat.component.html
// module id = ../../../../../src/app/chat/chat.component.html
// module chunks = main